import { Link } from "react-router-dom";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL, LEGAL_NAME, TIKTOK_URL } from "@/lib/site";

const SHOP_LINKS = [
  { label: "Shop", href: "/shop/men", testid: "footer-link-shop" },
  { label: "Jewelry", href: "/jewelry", testid: "footer-link-jewelry" },
  { label: "Track Order", href: "/track-order", testid: "footer-link-track-order" },
  { label: "FAQ", href: "/faq", testid: "footer-link-faq" },
  { label: "Contact", href: "/contact", testid: "footer-link-contact" },
];

const POLICY_LINKS = [
  { label: "Shipping", href: "/policies/shipping", testid: "footer-link-shipping" },
  { label: "Exchanges and Refunds", href: "/policies/refunds", testid: "footer-link-returns" },
  { label: "Terms", href: "/policies/terms", testid: "footer-link-terms" },
  { label: "Privacy", href: "/policies/privacy", testid: "footer-link-privacy" },
];

const linkCls = "font-['Oswald'] text-xs uppercase tracking-[0.2em] text-[#A8A6A1] hover:text-[#F2F0EB] transition-colors";

function Column({ heading, children }) {
  return (
    <div>
      <p className="text-[10px] uppercase tracking-[0.25em] text-[#8A8A8A] mb-4">{heading}</p>
      <ul className="space-y-3">{children}</ul>
    </div>
  );
}

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-[#8A8A8A]/20">
      <div className="px-6 sm:px-12 py-14">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          {/* Brand */}
          <div>
            <p className="font-['Oswald'] text-lg font-bold uppercase tracking-[0.3em] text-[#F2F0EB]">AERWEAR</p>
            <p className="mt-2 text-[10px] uppercase tracking-[0.25em] text-[#8A8A8A]">After Hours Athletics</p>
          </div>

          <nav aria-label="Footer" className="grid grid-cols-2 sm:grid-cols-3 gap-x-10 gap-y-10">
            <Column heading="Shop">
              {SHOP_LINKS.map((l) => (
                <li key={l.href}><Link to={l.href} data-testid={l.testid} className={linkCls}>{l.label}</Link></li>
              ))}
            </Column>
            <Column heading="Policies">
              {POLICY_LINKS.map((l) => (
                <li key={l.href}><Link to={l.href} data-testid={l.testid} className={linkCls}>{l.label}</Link></li>
              ))}
            </Column>
            <Column heading="Follow">
              <li>
                <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-link-instagram" className={linkCls}>
                  Instagram <span className="normal-case tracking-normal">{INSTAGRAM_HANDLE}</span>
                </a>
              </li>
              <li>
                <a href={TIKTOK_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-link-tiktok" className={linkCls}>TikTok</a>
              </li>
            </Column>
          </nav>
        </div>

        <div className="border-t border-[#8A8A8A]/20 mt-12 pt-6">
          <p data-testid="footer-legal" className="text-[10px] uppercase tracking-[0.25em] text-[#8A8A8A]">&copy; 2026 {LEGAL_NAME}. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
